/**
 * GÓI CUSTOM (giao diện) — Trà Dược Việt Nam: trang Sản phẩm FMRP + form lên đơn qua CRM.
 * Bật theo module `crm_products` (FMRP) / `crm_tdvn` (CRM). Khớp gói backend
 * bizcrm_backend_source/src/custom/tra-duoc-viet-nam.
 */
import { lazy } from 'react'
import { PackageSearch } from 'lucide-react'
import type { GoiCustomFE } from '../cong'

const goi: GoiCustomFE = {
  key: 'tra_duoc_viet_nam',
  ten: 'Trà Dược Việt Nam',
  routes: [
    {
      path: 'crm-products', permission: 'products.view', module: 'crm_products',
      element: lazy(() => import('./san-pham-fmrp/crm-products-page').then((m) => ({ default: m.CrmProductsPage }))),
    },
  ],
  nav: [
    // Sản phẩm đọc thẳng từ API FMRP — không lưu bản sao ở ChatMQL.
    { label: 'Sản phẩm (FMRP)', to: '/crm-products', icon: PackageSearch, permission: 'products.view', module: 'crm_products' },
  ],
  khe: {
    lenDon: { module: 'crm_tdvn', component: lazy(() => import('./don-hang/order-form').then((m) => ({ default: m.OrderForm }))) },
    sanPhamHoiThoai: { module: 'crm_products', component: lazy(() => import('./san-pham-fmrp/product-tab').then((m) => ({ default: m.ProductTab }))) },
  },
}

export default goi
